<template>
	<div>
		<div class="nav-buttons-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">I got the wrong book</h1>

			<v-base-nav-page :links="links" :nosearch="true">
			</v-base-nav-page>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import 'babel-polyfill';
	import 'vuetify/dist/vuetify.min.css';
	import BaseNavPage from './../../components/BaseNavPage';
	import BaseNavLinks from './../../components/BaseNavLinks';

	export default {
		name: "GotWrongBook",

		components: {
			'v-base-nav-page': BaseNavPage,
			BaseNavLinks,
		},

		data() {
			return {
				links: [
					{
						to: '/need_other_book/' + parseInt(this.$route.params.id),
						caption: 'The book I got was what I ordered,<br> but the professor says different materials should be listed for my course'
					},
					{
						to: '/received_wrong_book/' + parseInt(this.$route.params.id),
						caption: 'The book I got was not what I ordered'
					},
					{
						to: '/return/' + parseInt(this.$route.params.id),
						caption: 'I changed my mind about this book and want to return it'
					},
				]
			}
		},

		mounted() {
			const self = this;
		}
	}
</script>

<style scoped>

</style>